import { Component, Input } from '@angular/core';
import { QRCodeErrorCorrectionLevel } from 'qrcode';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
})
export class QrcodeComponent {
  @Input({ required: true }) public qrCodeUrl: string;
  @Input({ required: false }) public width = 200;
  @Input({ required: false }) public margin = 0;
  @Input({ required: false }) public errorCorrectionLevel: QRCodeErrorCorrectionLevel = 'M';
}
